import { SvgIcon, SvgIconProps } from '@mui/material'

const Backpack = (props: SvgIconProps) => (
    <SvgIcon {...props}>
        <svg fill="none" className="inline mr-1" viewBox="0 0 16 16">
            <path d="M0 0h16v16H0z"></path>
            <path
                stroke="#1A1A1A"
                strokeWidth="0.7"
                d="M9.443 3.21a1.21 1.21 0 1 0-2.421 0m4.842 9.08a.605.605 0 0 0 .605-.606v-2.42a.605.605 0 0 0-.605-.606m-7.235 0a.605.605 0 0 0-.61.6L4 11.68a.605.605 0 0 0 .6.61m6.054 1.21v-1.816a2.421 2.421 0 0 0-4.843 0V13.5zM8.233 3.21a3.63 3.63 0 0 1 3.631 3.632v5.842c0 .45-.365.816-.816.816H5.417a.816.816 0 0 1-.816-.816V6.842a3.63 3.63 0 0 1 3.632-3.631Zm-.904 3.632h1.816a.605.605 0 0 0 0-1.21H7.33a.605.605 0 1 0 0 1.21Z"
            ></path>
        </svg>
    </SvgIcon>
)

export default Backpack
